export default __webpack_public_path__ + "static/media/img3.1c0eaeb9.png";